import { IPhoneNumber } from '../types';

const formatNumberAsPhone = (data?: string): string | undefined => {
    if (!data) return;

    return data.length === 7 ? [data.slice(0, 3), data.slice(3)].join('-') : data;
};

export const formatPhoneNumber = (data?: IPhoneNumber): string => {
    const { areaCode, number, ext } = data ?? {};
    const numberAsString = number?.toString() ?? '';

    if (!areaCode && numberAsString.length === 10) {
        return [`(${numberAsString.slice(0, 3)})`, formatNumberAsPhone(numberAsString.slice(3)), ext]
            .filter(Boolean)
            .join('-');
    } else {
        return number
            ? [areaCode ? `(${areaCode})` : undefined, formatNumberAsPhone(number), ext].filter(Boolean).join('-')
            : '--';
    }
};

export const numberAsDollar = (value: number | string, options?: Intl.NumberFormatOptions): string => {
    const numericValue = typeof value === 'number' ? value : Number(value);
    const USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        ...options
    });

    return USDollar.format(numericValue);
};
